import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AlertsInfoCloseBoldIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm4.498 6.748c-.2 0-.39.08-.53.222l-3.969 3.97-3.97-3.97c-.141-.142-.33-.22-.53-.22s-.389.078-.53.22c-.142.141-.22.33-.22.53 0 .199.079.39.22.53l3.97 3.97-3.968 3.97c-.142.14-.222.33-.222.53s.08.39.222.53c.14.141.331.22.53.22s.39-.079.53-.22L12 13.06l3.97 3.97c.14.141.331.22.53.22s.39-.08.53-.22c.142-.14.222-.33.222-.53s-.08-.39-.222-.53L13.06 12l3.968-3.97c.142-.141.22-.33.22-.53s-.078-.389-.22-.53c-.14-.142-.33-.222-.53-.222z" transform="translate(-.002)"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
AlertsInfoCloseBoldIcon = __decorateClass([
  customElement("elm-alerts-info-close-bold-icon")
], AlertsInfoCloseBoldIcon);
export { AlertsInfoCloseBoldIcon };
